import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../store';
import CustomSnackbar from '@common/components/Feedback/CustomSnackbar';
import { selectRobotsData } from '../../store/robots/robots-slice-selectors';
import HttpFetchStatus from '@common/enums/api/http-fetch-status';
import { resetRobotsRestState } from '../../store/robots/robots-slice';

const GlobalSnackbars: React.FC = () => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const robotsData = useAppSelector((state) => selectRobotsData(state));

  return (
    <React.Fragment>
      <CustomSnackbar
        open={robotsData.rest.deleteStatus === HttpFetchStatus.Success}
        title={t('success-deleting')}
        onClose={() =>
          dispatch(resetRobotsRestState({ deleteError: null, deleteStatus: HttpFetchStatus.Idle }))
        }
      />
    </React.Fragment>
  );
};

export default GlobalSnackbars;
